export default __webpack_public_path__ + "media/images/react_icons/property/breakfast-a3e6c97b3c3597727b4725f9cb52de7f.svg";